import React, {Component} from 'react';
import PropTypes from 'prop-types';

import { Popup } from 'semantic-ui-react'
import {client} from '../Client';
import {arrayToCombo, arrayToComboAdd, convertNullToEmptyString} from '../Helpers'

class QueryFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value:this.props.value,
            tipo: this.props.tipo,
            itemList: [],
            itemListFiltered: [],
            itemsLoading: false,
            inEditing: false
        };
        this.onSearchClick = this.onSearchClick.bind(this)
        this.onDeleteClick = this.onDeleteClick.bind(this)
        this.onSearchKeyPress = this.onSearchKeyPress.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onLooseFocus = this.onLooseFocus.bind(this)
        this.loadDropdown = this.loadDropdown.bind(this)
        this.renderPopup = this.renderPopup.bind(this)
        this.createFilteredList = this.createFilteredList.bind(this)
    }

    componentWillMount() {
        this.loadDropdown();
    }

    componentWillReceiveProps(nextProps) {
        this.setState ({
            value: nextProps.value,
            tipo: nextProps.tipo,
        });
    }

    onInputChange(ev){
        if (ev.target.value !== undefined){
            let newValue = ev.target.value.replace(/"/g, "'");
            let filtered = [];
            if (newValue.length > 0 && this.state.itemList){
                filtered = this.state.itemList.filter((it)=>(it.value.search(newValue) !== -1));
            }
            this.setState({ value: newValue, itemListFiltered: filtered, inEditing: true });
        }

    }

    setContent(value){
        if (value){
            let newValue = value.replace(/"/g, "'");
            this.setState({ value: newValue, itemListFiltered: [], inEditing: false });
        }
    }


    onSearchClick() {
        if (this.state.value !== undefined && this.state.value.length > 2){
            this.saveValue(this.state.value);
            this.setState({ itemListFiltered: [], inEditing: false });
        }
        this.doSearch(this.state.value)
    }

    onDeleteClick() {
        this.setState({value:'', inEditing: false});
        this.doSearch('')
    }

    onSearchKeyPress(ev) {
        if (ev.key === 'Enter')
        {
            this.doSearch(ev.target.value)
        }
    }

    onLooseFocus(){
        this.setState({ itemListFiltered: [], inEditing: false });
    }

    doSearch(sql) {
        if (this.props.onChangeFilter !== undefined)
        {
            this.props.onChangeFilter(sql)
        }
    }

    onLoading(value){
        this.setState({ itemsLoading: value });
        if (this.props.onLoading !== undefined){
            this.props.onLoading(value)
        }
    }

    createFilteredList(value, items){
        let filtered = [];
        if (value && value.length > 0 && items){
            filtered = items.filter((it)=>(it.value.search(value) !== -1));
        }
        return filtered;
    }

    loadDropdown(){
        this.onLoading(true);
        client.loadTestiPerTipoList(this.state.tipo).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.onLoading(false);
                    let itemList = arrayToCombo(data, "valore", "valore", "valore", false);
                    this.setState({ error: null, itemList: itemList, itemListFiltered: this.createFilteredList(this.state.value, itemList) });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.onLoading(false);
                    this.setState({
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.onLoading(false);
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    saveValue(value){
        this.onLoading(true);
        client.saveTestiPerTipo(
            this.state.tipo, value
        ).then((response) => {

            if (response.ok){
                this.onLoading(false);
                this.setState({
                    inError: false,
                    fieldErrors: {},
                    fieldErrorsText: [],
                });
                if (response.status === 201){
                    response.json().then((data) => {
                        data = convertNullToEmptyString(data);
                        let itemList = arrayToComboAdd(this.state.itemList, data, 'valore', 'valore', 'valore');
                        this.setState({
                            itemList: itemList,
                        });
                    })
                }
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else{
                this.onLoading(false);
                this.setState({
                    inError: true,
                    fieldErrors: {'forma': 'errore salvataggio testo'},
                    fieldErrorsText: ["errore caricamento testo"],
                    errorTitle: "Errore imprevisto",
                });
            }
        }).catch((error) => {
            this.onLoading(false);
            this.setState({
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    renderPopup(){
        if ((this.state.itemListFiltered === undefined ||
            this.state.itemListFiltered.length === 0) ||
            !this.state.inEditing
        ){
            return null;
        }
        let i=0;
        return <div className="menu transition visible">
            <div className="ui middle aligned selection list">
                {
                    this.state.itemListFiltered.map((item) => {
                        return (<div className="item" key={i++} onClick={()=>this.setContent(item.value)}>
                            <div className="content">
                                <div className="header">{item.value}</div>
                            </div>
                        </div>)
                    })
                }
            </div>
        </div>
    }

    render() {

        return (
                <div className="sixteen wide field">

                    <div className="ui visible fluid selection dropdown " style={{width: "100%", padding:"0", margin:"0", border:"0", minHeight: "50px"}}>
                    <div className="ui action input" style={{width: "100%"}}>
                        <input
                            autoComplete="nope"
                            type="text"
                            placeholder={this.props.placeholder}
                            ref="searchField"
                            value={this.state.value}
                            onChange={this.onInputChange}
                            onKeyPress={this.onSearchKeyPress}
                            //onBlur={this.onLooseFocus}
                        />
                        <button title="Conferma la condizione scritta, salvandola anche per uso futuro" className="ui right icon button" onClick={this.onSearchClick}>
                            <i className="circular checkmark icon"></i>
                        </button>

                        <button title="Cancella la condizione scritta" className="ui right  icon button" onClick={this.onDeleteClick}>
                            <i className="circular cancel icon"></i>
                        </button>
                        {
                            this.props.showPopup ? (
                                <Popup
                                    trigger={<button className="ui right  icon button">
                                                <i className="circular help icon"></i>
                                            </button>
                                    }
                                    on="click"
                                    position={this.props.popupPosition}
                                    hideOnScroll
                                    flowing
                                >
                                    <Popup.Header>{this.props.popupHeader}</Popup.Header>
                                    <Popup.Content>
                                        {this.props.children}
                                    </Popup.Content>
                                </Popup>
                            ) : <button className="ui right  icon button">
                                <i className="circular help icon"></i>
                            </button>
                        }


                    </div>
                    {this.renderPopup()}
                    </div>

                </div>

        )
    }
}

QueryFilter.PropTypes = {
    value: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    popupHeader: PropTypes.string.isRequired,
    showPopup: PropTypes.bool.isRequired,
    popupPosition: PropTypes.string.isRequired,
    onChangeFilter: PropTypes.func,
    tipo: PropTypes.string.isRequired,
    maxlength: PropTypes.number.isRequired,
}

QueryFilter.defaultProps = {
    value: '',
    showPopup: false,
    popupHeader: "Query di ricerca",
    popupPosition: "bottom left",
    maxlength: 255,
};

export default QueryFilter;




/** WEBPACK FOOTER **
 ** ./src/components/QueryFilter.jsx
 **/